import {NgForOf, NgIf} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {PAGES_AND_PATHS} from 'src/app/constants/pages-and-paths';
import {LystTypeFilter} from 'src/app/enums/list-enums';
import {TimeAgoModule} from 'src/app/pipes/time-ago/time-ago.module';
import {SingleListItem} from 'src/app/services/http-services/lists/lists-http-intterfaces';
import {ListsHttpService} from 'src/app/services/http-services/lists/lists-http.service';
import {MatchLocaleModule} from '../../../pipes/match-locale/match-locale.module';

@Component({
  selector: 'app-lists',
  standalone: true,
  imports: [RouterModule, NgForOf, TimeAgoModule, TranslateModule, NgIf, MatchLocaleModule],
  templateUrl: './lists.component.html',
})
export class ListsComponent implements OnInit {
  pageNum = 1;
  lists: SingleListItem[] = [];
  activeListType: LystTypeFilter = LystTypeFilter.allLysts;
  PAGES_AND_PATHS = PAGES_AND_PATHS;

  constructor(
    private listsHttpService: ListsHttpService
  ) {
  }

  ngOnInit(): void {
    this.getMyLystsV2(this.pageNum, this.activeListType);
  }

  getMyLystsV2(pageNumber: number, filter: LystTypeFilter): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.listsHttpService.getMyLystsV2(pageNumber, filter).then((res: any) => {
        try {
          this.lists = [...this.lists, ...res.data];
        } catch (e) {
        }
        resolve(true);
      }, error => {
        reject(false);
      })
    });
  }
}
